import BaseGrid from 'components/atoms/base-grid';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import ExpandableNormalReadingsReportFilters from 'components/templates/rpm/practice/normal-readings-report/expandable-filters';
import NormalReadingsReportHeader from 'components/templates/rpm/practice/normal-readings-report/header';
import NormalReadingsTable from 'components/templates/rpm/practice/normal-readings-report/table';
import {
  useNormalReadingsFilter,
  useSendNormalReadingsReport,
} from 'infrastructure/hooks/normal-reading-report';

import type { FC } from 'react';

interface NormalReadingsReportProps {}

const NormalReadingsReport: FC<NormalReadingsReportProps> = () => {
  const { count, filter, resetFilter, updateFilter } =
    useNormalReadingsFilter();

  const { sendReportToEmail, isLoading } = useSendNormalReadingsReport();

  const handleSend = () => {
    const { page: _, ...data } = filter;
    sendReportToEmail(data);
  };

  return (
    <>
      <NormalReadingsReportHeader
        isLoading={isLoading}
        sendReportToEmail={handleSend}
      />
      <BaseGrid rowGap={35}>
        <ExpandableNormalReadingsReportFilters
          filter={filter}
          count={count}
          updateFilter={updateFilter}
          resetFilter={resetFilter}
        />
        <NormalReadingsTable filter={filter} updateFilter={updateFilter} />
      </BaseGrid>
      <ScrollToTopButton />
    </>
  );
};
export default NormalReadingsReport;
